exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3seut{height:100vh;overflow:hidden}._3OqbR{height:100%;padding-top:20px;border-right:1px solid #d9d9d9}body.reader-night-mode ._3OqbR{border-color:#2e2e2e;background-color:#3d3d3d}._1zpgA{position:relative;height:100%;overflow-y:auto;color:#333;background-color:#fcfaf2;padding:40px 40px 80px;font-size:16px;line-height:1.75}body.reader-night-mode ._1zpgA{background-color:#4d4d4d}._25Ia0{margin-bottom:20px;font-size:26px;color:inherit}body.reader-night-mode ._25Ia0{color:#b3b3b3}._28EL5{position:relative;height:100vh;padding-top:0;background-color:#f2f2f2;text-align:center}body.reader-night-mode ._28EL5{background-color:#3d3d3d}._28EL5:after{content:\"\";height:100%}._28EL5 span,._28EL5:after{display:inline-block;vertical-align:middle}._28EL5 span{font-size:64px;color:#e6e6e6;text-shadow:0 1px 0 #fff}body.reader-night-mode ._28EL5 span{color:#595959;text-shadow:0 1px 0 #666}", ""]);

// exports
exports.locals = {
	"page": "_3seut",
	"editor": "_3OqbR",
	"preview": "_1zpgA",
	"title": "_25Ia0",
	"no-notes": "_28EL5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/pages/PreviewPage/PreviewPage.scss
// module id = djON
// module chunks = 4